// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"532":"f11919181b3c6bbfe040","691":"4647eb3ce8d90cdce498"}[chunkId] + ".js";
};